import MenuButton from "components/Common/Buttons/MenuButton";

import ThemeToggleButton from "components/Common/Buttons/ThemeToggleButton";
import useBoolean from "hooks/useBoolean";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { Floating } from "styles/keyFrame/floating";
import media from "styles/media";

const HeaderConatiner = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;

  button {
    position: absolute;
    top: 0;
    right: 0;
    transition: 0.8s all ease-out;
  }

  button:first-child {
    opacity: 0;
    transform: scale(0.5);
  }

  &.open button:first-child {
    transform: translateX(-4.4rem) scale(1);
    opacity: 1;
  }

  &.open button:last-child {
    transform: scale(0.8);
  }

  .prev-page-button {
    position: fixed;
    top: 0;
    left: 0;
    width: 2.4rem;
    height: 2.4rem;
    margin: 2rem;
    animation: ${() => Floating(8)} 2s linear alternate infinite;
    svg {
      width: 3rem;
      height: 3rem;
    }
  }

  .home-button {
    position: fixed;
    top: 0;
    left: 4.3rem;
    margin: 2.3rem;
    width: 2.4rem;
    height: 2.4rem;
    animation: ${() => Floating(8)} 2s linear alternate infinite;

    svg {
      width: 2.4rem;
      height: 2.4rem;
    }
  }
`;

export default function Header() {
  const [menuOpen, onToggleMenuOpen] = useBoolean(false);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <HeaderConatiner className={`${menuOpen ? "open" : "close"}`}>
      <ThemeToggleButton />
      {location.pathname.split("/").length >= 3 && (
        <>
          <button
            tabIndex={-1}
            className="prev-page-button"
            onClick={() => {
              let tokens = location.pathname.split("/");
              let path = tokens.slice(0, -1).join("/");
              navigate(-1);
            }}
          >
            <svg
              clipRule="evenodd"
              fillRule="evenodd"
              strokeLinejoin="round"
              strokeMiterlimit="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m9.474 5.209s-4.501 4.505-6.254 6.259c-.147.146-.22.338-.22.53s.073.384.22.53c1.752 1.754 6.252 6.257 6.252 6.257.145.145.336.217.527.217.191-.001.383-.074.53-.221.293-.293.294-.766.004-1.057l-4.976-4.976h14.692c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-14.692l4.978-4.979c.289-.289.287-.761-.006-1.054-.147-.147-.339-.221-.53-.221-.191-.001-.38.071-.525.215z"
                fillRule="nonzero"
              />
            </svg>
          </button>
          <button
            tabIndex={-1}
            className="home-button"
            onClick={() => {
              navigate("/");
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M21 13v10h-6v-6h-6v6h-6v-10h-3l12-12 12 12h-3zm-1-5.907v-5.093h-3v2.093l3 3z" />
            </svg>
          </button>
        </>
      )}
      <MenuButton state={menuOpen} onClick={onToggleMenuOpen} />
    </HeaderConatiner>
  );
}
